import React from 'react'
import ElementsListing from '../../components/ElementsListing'
import TopSideBar from '../../components/TopSideBar'
import { useProject } from '../../context/ProjectContext';

export default function ElementsListingPage({ setBlockScreen }: any) {
  const { isProjectUndefined } = useProject();

  return <>
    <TopSideBar currentSection='elements' />

    {!isProjectUndefined() && (
      <ElementsListing
        setBlockScreen={setBlockScreen}
      />
    )}
  </>
}